import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";

const CustomerLedgerMemoSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    return <>
        <CRow className={'mb-1'}>
            <CCol>
                <CFormLabel>By #</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'customer_ledger_memo_number',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.customer_ledger_memo_number || ''}
                />
                <CFormText>Example: UYUI7883, KIU39723</CFormText>
            </CCol>
        </CRow>
    </>;
}

export default CustomerLedgerMemoSearch;
